import Convention from "models/convention-api/v1/Convention"

const getConventionAddress = (convention: Convention) => {
  const { address_street, address_street2, city, state, zipcode } = convention

  // output: 123 Huntington Ave, Boston, MA 04112
  return [address_street, address_street2, city, state, zipcode].filter((item) => !!item).join(", ")
}

export default getConventionAddress
